<template>
  <div class="p-grid">
      <div class="p-col-12">
          <div class="card p-shadow-1">
            <h5>{{ titulo }}</h5>
            <hr>
            <Panel header="Plano">
                <div class="p-fluid p-formgrid p-grid"> 
                    <div class="p-field p-col-12 p-md-6">
                        <label for="nome">Nome</label>
                        <InputText id="nome" v-model.trim="plano.nome" autocomplete="off" maxlength="100"/> 
                        <small class="p-invalid" v-if="enviandoForm && !plano.nome">Informe o nome do Plano</small>
                    </div> 
                    <div class="p-field p-col-12 p-md-2">
                        <label for="quantidadePessoas">Qtd. Pessoas</label>
                        <InputNumber id="quantidadePessoas" v-model.number="plano.quantidadePessoas" 
                            :useGrouping="false" autocomplete="off" maxlength="15" class="p-text-right"/>
                        <small class="p-invalid" v-if="enviandoForm && !plano.quantidadePessoas">Informe o limite de Pessoas</small>
                    </div>
                    <div class="p-field p-col-12 p-md-2">
                        <label for="quantidadeUsuarios">Qtd. de Usuários</label>
                        <InputNumber id="quantidadeUsuarios" type="text" v-model.number="plano.quantidadeUsuarios" 
                            :useGrouping="false" autocomplete="off" maxlength="15" class="p-text-right"/>                        
                    </div>
                    <div class="p-field p-col-12 p-md-2">
                        <label>Qtd. de CNPJs</label>
                        <InputNumber type="text" v-model.number="plano.quantidadeCNPJs" 
                            :useGrouping="false" autocomplete="off" maxlength="15" class="p-text-right"/>                                     
                    </div>
                    <div class="p-field p-col-12 p-md-2">
                        <label>Qtd. de Usuários App</label>
                        <InputNumber type="text" v-model.number="plano.quantidadeUsuariosApp" 
                            :useGrouping="false" autocomplete="off" maxlength="15" class="p-text-right"/>                                               
                    </div>
                    <div class="p-field p-col-12 p-md-2">
                        <label for="valor">Valor Mensal</label>
                        <InputNumber v-model.number="plano.valorMensal" currency="BRL" locale="pt-BR" autocomplete="off" maxlength="15" class="p-text-right"/>
                        <small class="p-invalid" v-if="enviandoForm && !plano.valorMensal">Informe o valor do Plano</small>
                    </div>
                    <div class="p-field p-col-12 p-md-2">
                        <label for="valor">Valor Anual</label>
                        <InputNumber v-model.number="plano.valorAnual" currency="BRL" locale="pt-BR" autocomplete="off" maxlength="15" class="p-text-right"/>
                        <small class="p-invalid" v-if="enviandoForm && !plano.valorAnual">Informe o valor do Plano</small>
                    </div> 
                    <div class="p-field p-col-12 p-md-2">
                        <label for="validade">Validade</label>
                        <Dropdown v-model="plano.validade" :options="validades" optionLabel="nome" optionValue="id"/>
                    </div>  
                    <div class="p-field p-col-12 p-md-2">
                        <div class="p-field-checkbox">
                            <Checkbox v-model="plano.ativo" :binary="true"/>
                            <label>Ativo</label>
                        </div>
                    </div>                                        
                </div>  
            </Panel>            
            <FormPerfil ref="formPerfil" />
            <FormBeneficio ref="formBeneficio" />
            <Button label="Fechar" class="p-button-secondary" icon="pi pi-times" @click="cancelar"/>            
            <Button label="Salvar" class="p-ml-2" icon="pi pi-check" @click="salvar"/>
          </div>
      </div>      
  </div>
</template>

<script>

import PlanoService from '@/service/PlanoService';
import MenuService from '@/service/MenuService';
import Plano from '@/model/Plano';
import FormPerfil from '@/components/pages/cadastro/plano/FormPerfil';
import FormBeneficio from '@/components/pages/cadastro/plano/FormBeneficio';
import { exibirMensagem } from '@/global';
import { mapGetters } from 'vuex';

export default {
    planoService: null,
    menuService: null,
    props: ['id'],// Para edição
	data() {
		return {      
            titulo: 'Novo Plano',  
			enviandoForm: false,			
			plano: new Plano(),
            cacheBeneficios: [],
            validades:[{nome: 'Produção', id: 'Producao'}, {nome: 'Teste', id: 'Teste'}],
		}
	},
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao','getPermissoes']),
        salvar() {
            this.enviandoForm = true;
            if(this.plano.nome == '' || this.plano.quantidadePessoas == null || this.plano.quantidadePessoas <= 0
                || this.plano.valorAnual == null || this.plano.valorAnual <= 0 || this.plano.valorMensal == null
                || this.plano.valorMensal <= 0) {
                window.scrollTo(0, 0);
                return;
            }
            if(this.plano.beneficios.length == 0) {
                return;
            }
            let beneficiosExcluir = this.$refs.formBeneficio.getBeneficiosExcluir();
            let requisicao = {
                usuarioRequisicao: {...this.getDadosRequisicao()},
                beneficiosExcluir: beneficiosExcluir,
                plano: this.plano
            }	
            this.planoService.salvar(requisicao)
				.then(resp => {	        
                    exibirMensagem(this, resp);
                    if(this.plano.id == null) {
                        this.plano = new Plano();   
                        this.plano.beneficios = [...this.cacheBeneficios];
                        this.$refs.formPerfil.reset(this.plano);
                        this.$refs.formBeneficio.carregar(this.plano);   
                        this.enviandoForm = false; 
                    } else {
                        setTimeout(() => {
                            this.$router.push('/cadastro/planos');                            
                        }, 600);
                    }
                })
                .catch(erro => {exibirMensagem(this, erro)});
        },
        cancelar() {
            this.$router.push('/cadastro/planos');
        },      
        listarMenu() {
            this.menuSelecionado = null;
            this.exibirPermissoes = false;
            let requisicao = {
                usuarioRequisicao: {...this.getDadosRequisicao()}
            }	
            this.menuService.listar(requisicao)
				.then(resp => {	
                    if(this.plano.id == null) {
                        this.plano.beneficios = [...this.cacheBeneficios];
                    }
                    this.$refs.formPerfil.carregar(this.plano, resp.data);
                    this.$refs.formBeneficio.carregar(this.plano);
                })
                .catch(erro => {exibirMensagem(this, erro)});            
        },
        verificarEdicao() {
            if(this.id != null) {
                let requisicao = {
                    idPlano: this.id,                   
                    usuarioRequisicao: {...this.getDadosRequisicao()}
                };               
                this.planoService.buscar(requisicao)
                    .then(resp => {	                        	
                        this.plano = resp.data; 
                        this.listarMenu();	         
                    });
            }		
        },       
    },
    created() {
		this.planoService = new PlanoService();	
        this.menuService = new MenuService();
        if(this.id != null) {
            // Após o retorno listar os itens de menu.
            // Quando vem /cadatro/plano/id/editar.
            this.verificarEdicao();
        } else {
            this.listarMenu();	
        }     
        // Qunado for uma plano novo.
        let jsonBeneficios = sessionStorage.getItem('sessionBeneficiosPlanoNovo');    
        if(jsonBeneficios != null) {           
            this.cacheBeneficios = JSON.parse(jsonBeneficios);
        }
	},
    components: {
        'FormPerfil': FormPerfil,
        'FormBeneficio': FormBeneficio,
    }
}
</script>

<style>

</style>